var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMechamism(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19.375C17.6401 19.375 19.375 17.6401 19.375 15.5C19.375 13.3599 17.6401 11.625 15.5 11.625C13.3599 11.625 11.625 13.3599 11.625 15.5C11.625 17.6401 13.3599 19.375 15.5 19.375Z",
    stroke: "#474747",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.58398 16.6367V14.3634C2.58398 13.02 3.6819 11.9092 5.03815 11.9092C7.37607 11.9092 8.3319 10.2559 7.15648 8.22794C6.48482 7.06544 6.88523 5.55419 8.06065 4.88252L10.2952 3.60377C11.3157 2.99669 12.6332 3.35835 13.2402 4.37877L13.3823 4.62419C14.5448 6.6521 16.4565 6.6521 17.6319 4.62419L17.774 4.37877C18.3811 3.35835 19.6986 2.99669 20.719 3.60377L22.9536 4.88252C24.129 5.55419 24.5294 7.06544 23.8577 8.22794C22.6823 10.2559 23.6382 11.9092 25.9761 11.9092C27.3194 11.9092 28.4302 13.0071 28.4302 14.3634V16.6367C28.4302 17.98 27.3323 19.0909 25.9761 19.0909C23.6382 19.0909 22.6823 20.7442 23.8577 22.7721C24.5294 23.9475 24.129 25.4459 22.9536 26.1175L20.719 27.3963C19.6986 28.0034 18.3811 27.6417 17.774 26.6213L17.6319 26.3759C16.4694 24.3479 14.5577 24.3479 13.3823 26.3759L13.2402 26.6213C12.6332 27.6417 11.3157 28.0034 10.2952 27.3963L8.06065 26.1175C6.88523 25.4459 6.48482 23.9346 7.15648 22.7721C8.3319 20.7442 7.37607 19.0909 5.03815 19.0909C3.6819 19.0909 2.58398 17.98 2.58398 16.6367Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMechamism);
export default __webpack_public_path__ + "static/media/mechamism.5773dcd04a98a63363f1e94377eb0f43.svg";
export { ForwardRef as ReactComponent };